export const config = {
    entityKey: 'aliases',
    titles: {
        singular: 'Alias',
        plural: 'Aliases'
    }
}